var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualCasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1251_626766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6365 22.1923H12.4715L8.44531 20.1098V17.7959H14.554V20.1098C14.554 21.2552 15.4911 22.1923 16.6365 22.1923Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5544 22.1924H6.36328C7.50865 22.1924 8.44577 21.2552 8.44577 20.1099H12.4719C12.4719 21.2552 13.4091 22.1924 14.5544 22.1924Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.611 0.580566H20.2227V17.3331L22.9993 15.9447V1.96888C22.9993 1.20529 22.3745 0.580566 21.611 0.580566Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2233 0.460449H1.38831C0.624729 0.460449 0 1.08522 0 1.8488V15.8247L21.6117 17.213V1.8488C21.6117 1.08522 20.9869 0.460449 20.2233 0.460449Z",
    fill: "#483A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6576 7.52246H10.3438V11.6865H12.6576V7.52246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.312 8.20269C19.1765 8.0672 18.9567 8.0672 18.8212 8.20269C17.349 9.67496 14.9534 9.67496 13.4811 8.20269L12.9902 8.69355C13.8617 9.56499 15.0064 10.0007 16.1511 10.0007C17.2959 10.0007 18.4406 9.56499 19.312 8.69355C19.4476 8.55802 19.4476 8.33826 19.312 8.20269Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6566 7.52246L11.4996 9.60445H10.1113V13.0758H13.5822V8.44803C13.5821 7.93682 13.1678 7.52246 12.6566 7.52246Z",
    fill: "#EA2820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51858 8.20269C8.04631 9.67496 5.65072 9.67496 4.1784 8.20269C4.04287 8.0672 3.82307 8.0672 3.68758 8.20269C3.55206 8.33826 3.55206 8.55802 3.68758 8.69355C4.55902 9.56499 5.70377 10.0007 6.84847 10.0007C7.99317 10.0007 9.13791 9.56499 10.0094 8.69355L9.51858 8.20269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3435 7.52246C9.83237 7.52246 9.41797 7.93682 9.41797 8.44803V13.0758H11.5005V9.60445L10.3435 7.52246Z",
    fill: "#FF443E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.96924V6.13421C12.6501 6.13421 13.5825 5.20186 13.5825 4.05173C13.5825 2.90159 12.6501 1.96924 11.5 1.96924Z",
    fill: "#E0843D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1946 4.05173C12.1946 2.90159 11.8838 1.96924 11.5005 1.96924C10.3503 1.96924 9.41797 2.90159 9.41797 4.05173C9.41797 5.20186 10.3503 6.13421 11.5005 6.13421C11.8838 6.13421 12.1946 5.20182 12.1946 4.05173Z",
    fill: "#F7983D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2224 13.1685H15.3633V17.3334H20.2224V13.1685Z",
    fill: "#974D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8357 13.1685H2.77734V17.3334H18.8357V13.1685Z",
    fill: "#B25B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2227 15.9448V18.7215H21.611C22.3745 18.7215 22.9993 18.0968 22.9993 17.3332V15.9449H20.2227V15.9448Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9448V17.3331C0 18.0967 0.624729 18.7214 1.38831 18.7214H20.2233C20.9869 18.7214 21.6116 18.0967 21.6116 17.3331V15.9448H0Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9176 12.4741H19.5293V13.8624H20.9176C21.301 13.8624 21.6118 13.5516 21.6118 13.1683C21.6118 12.7849 21.301 12.4741 20.9176 12.4741Z",
    fill: "#C96F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2237 13.1683C20.2237 12.7849 19.9129 12.4741 19.5295 12.4741H2.08285C1.69949 12.4741 1.38867 12.7849 1.38867 13.1683C1.38867 13.5517 1.69949 13.8625 2.08285 13.8625H19.5295C19.9129 13.8625 20.2237 13.5517 20.2237 13.1683Z",
    fill: "#E0843D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8355 22.5393H4.16543C3.97374 22.5393 3.81836 22.384 3.81836 22.1923C3.81836 22.0006 3.97374 21.8452 4.16543 21.8452H18.8354C19.0271 21.8452 19.1825 22.0006 19.1825 22.1923C19.1825 22.384 19.0272 22.5393 18.8355 22.5393Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7324 2.71473C4.73842 1.72074 3.12689 1.72074 2.13281 2.71473V6.31432C3.1268 7.3083 4.73864 7.30803 5.7324 6.31432V2.71473Z",
    fill: "#FFF5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93386 4.51415L2.13406 6.31395C1.14007 5.31996 1.14034 3.70812 2.13406 2.71436L3.93386 4.51415Z",
    fill: "#EA2820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73339 6.3139L3.93359 4.51415L5.73339 2.71436C6.72738 3.70839 6.72738 5.31991 5.73339 6.3139Z",
    fill: "#EA2820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93431 5.67135C4.57328 5.67135 5.09127 5.15336 5.09127 4.51439C5.09127 3.87541 4.57328 3.35742 3.93431 3.35742C3.29533 3.35742 2.77734 3.87541 2.77734 4.51439C2.77734 5.15336 3.29533 5.67135 3.93431 5.67135Z",
    fill: "#D40B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8652 2.71473C19.8712 1.72074 18.2597 1.72074 17.2656 2.71473V6.31432C18.2596 7.3083 19.8715 7.30803 20.8652 6.31432V2.71473Z",
    fill: "#FFF5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0667 4.51415L17.2669 6.31395C16.2729 5.31996 16.2732 3.70812 17.2669 2.71436L19.0667 4.51415Z",
    fill: "#9682C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8662 6.3139L19.0664 4.51415L20.8662 2.71436C21.8602 3.70839 21.8602 5.31991 20.8662 6.3139Z",
    fill: "#9682C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0671 5.67135C19.7061 5.67135 20.2241 5.15336 20.2241 4.51439C20.2241 3.87541 19.7061 3.35742 19.0671 3.35742C18.4281 3.35742 17.9102 3.87541 17.9102 4.51439C17.9102 5.15336 18.4281 5.67135 19.0671 5.67135Z",
    fill: "#7B68AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1251_626766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualCasino);
export default __webpack_public_path__ + "static/media/VirtualCasino.213aafbef210b827b1d91855af80fe60.svg";
export { ForwardRef as ReactComponent };